import React, { useState, useEffect } from 'react';
import {
    Box, Typography, TextField, Select, MenuItem, FormControl, InputLabel, Grid
} from '@mui/material';
import { JobRole, JobLevel } from '../../services/jobRoleService';

interface RoleLevelChangeFormProps {
    jobRoles: JobRole[];
    selectedRoleId: string;
    setSelectedRoleId: (value: string) => void;
    selectedLevelId: string;
    setSelectedLevelId: (value: string) => void;
    justification: string;
    setJustification: (value: string) => void;
    isViewMode: boolean;
}

const RoleLevelChangeForm: React.FC<RoleLevelChangeFormProps> = ({
    jobRoles,
    selectedRoleId,
    setSelectedRoleId,
    selectedLevelId,
    setSelectedLevelId,
    justification,
    setJustification,
    isViewMode
}) => {
    const [availableLevels, setAvailableLevels] = useState<JobLevel[]>([]);

    useEffect(() => {
        if (selectedRoleId) {
            const selectedRole = jobRoles.find(role => role.id.toString() === selectedRoleId);
            setAvailableLevels(selectedRole ? selectedRole.levels : []);
            // Se o nível selecionado anteriormente não pertence ao novo cargo, limpe-o
            if (selectedRole && !selectedRole.levels.find(level => level.id.toString() === selectedLevelId)) {
                setSelectedLevelId('');
            }
        } else {
            setAvailableLevels([]);
            setSelectedLevelId('');
        }
    }, [selectedRoleId, jobRoles, selectedLevelId, setSelectedLevelId]);

    return (
        <Box sx={{
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            p: 2,
            mt: 3,
            backgroundColor: '#f8f9fa'
        }}>
            <Typography variant="subtitle1" sx={{ fontSize: '0.9rem', fontWeight: 'bold', mb: 2 }}>
                MUDANÇA DE CARGO / NÍVEL TÉCNICO
            </Typography>

            <Grid container spacing={1.5}>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth size="small" margin="dense" disabled={isViewMode}>
                        <InputLabel id="role-select-label" sx={{ fontSize: '0.85rem' }}>Novo Cargo *</InputLabel>
                        <Select
                            labelId="role-select-label"
                            value={selectedRoleId}
                            label="Novo Cargo *"
                            onChange={(e) => setSelectedRoleId(e.target.value)}
                            sx={{ fontSize: '0.85rem', height: 40 }}
                        >
                            <MenuItem value="" sx={{ fontSize: '0.85rem' }}><em>-- Selecione --</em></MenuItem>
                            {jobRoles.map(role => (
                                <MenuItem key={role.id} value={role.id.toString()} sx={{ fontSize: '0.85rem' }}>
                                    {role.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth size="small" margin="dense" disabled={availableLevels.length === 0 || isViewMode}>
                        <InputLabel id="level-select-label" sx={{ fontSize: '0.85rem' }}>Novo Nível Técnico *</InputLabel>
                        <Select
                            labelId="level-select-label"
                            value={selectedLevelId}
                            label="Novo Nível Técnico *"
                            onChange={(e) => setSelectedLevelId(e.target.value)}
                            sx={{ fontSize: '0.85rem', height: 40 }}
                        >
                            <MenuItem value="" sx={{ fontSize: '0.85rem' }}><em>-- Selecione --</em></MenuItem>
                            {availableLevels.map(level => (
                                <MenuItem key={level.id} value={level.id.toString()} sx={{ fontSize: '0.85rem' }}>
                                    {level.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Justificativa (Opcional)"
                        value={justification}
                        onChange={(e) => setJustification(e.target.value)}
                        variant="outlined"
                        size="small"
                        margin="dense"
                        InputLabelProps={{ style: { fontSize: '0.85rem' } }}
                        InputProps={{ style: { fontSize: '0.85rem' }, sx: { height: 40 } }}
                        placeholder="Ex: Conclusão de projetos estratégicos..."
                        disabled={isViewMode}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default RoleLevelChangeForm;
